import { useState } from 'react';
import { useAuthContext } from '../../context/AuthContext';
import { publishAppToast } from '../../utils/appToast';
import { isVdoCipherLesson } from '../../utils/vdocipherMappers';

export default function LessonOfflineDownloadButton({
  lesson,
  downloadLesson,
  actionLoading = false,
  onDownloaded,
  onError,
}) {
  const { isLoggedIn, openAuthPopup } = useAuthContext();
  const [message, setMessage] = useState(null);

  if (!lesson || !isVdoCipherLesson(lesson) || !downloadLesson) return null;

  const handleDownload = async () => {
    if (!isLoggedIn) {
      openAuthPopup();
      return;
    }

    setMessage(null);
    const result = await downloadLesson(lesson.id);

    if (result.success) {
      setMessage('Added to offline downloads.');
      onDownloaded?.();
    } else if (result.message) {
      onError?.(result.message);
      publishAppToast(result.message, 'error');
    }
  };

  return (
    <div className="flex flex-col items-start gap-2">
      <button
        type="button"
        disabled={actionLoading || lesson.isDownloaded}
        onClick={handleDownload}
        className="inline-flex items-center gap-2 rounded-full border border-[#D9D9D9] bg-white px-5 py-2 text-sm font-semibold text-[#666666] shadow-sm transition hover:border-[#9369CC] hover:text-[#9369CC] disabled:cursor-not-allowed disabled:opacity-60"
      >
        <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5m0 0l5-5m-5 5V4" />
        </svg>
        {lesson.isDownloaded ? 'Downloaded' : actionLoading ? 'Preparing...' : 'Download offline'}
      </button>
      {message ? <p className="text-xs font-medium text-[#9369CC]">{message}</p> : null}
    </div>
  );
}
